export default __webpack_public_path__ + "static/broderie15.mobile.inspirations-6b445b9a1ecbb204456269975788c5eb.jpg";